import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Tag } from 'grab-ui';

const backgroundColorMap = {
  DRAFT: '#F5F5F5',
  ACTIVE: '#E6F7ED',
  DEACTIVATED: '#FFE4E0',
};

const textColorMap = {
  DRAFT: '#707070',
  ACTIVE: '#00B14F',
  DEACTIVATED: '#AC1E11',
};

const UCDStatusLabel = ({ status, labelSize }) => {
  const displayStatus = _.toUpper(status);

  return (
    <Tag
      style={{
        backgroundColor: backgroundColorMap[displayStatus],
        color: textColorMap[displayStatus],
      }}
      size={labelSize}
    >
      {displayStatus}
    </Tag>
  );
};

UCDStatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  labelSize: PropTypes.string.isRequired,
};

export default UCDStatusLabel;
